/** App context value sent as messageAnnotationAppContext for calendar event drafting scenarios */
export const CALENDAR_EVENT_DRAFTING_APP_CONTEXT = 'CalendarEventDrafting';
